const getDate = () => {
  const date = new Date();
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const dateTimeFormat = new Intl.DateTimeFormat('en', {
    year: 'numeric',
    month: 'short'
  });
  const [{ value: month }, , { value: year }] = dateTimeFormat.formatToParts(lastDay);

  return `${month} ${year}`;
};

const removeCentsAddCommas = arg => {
  return Number(parseFloat(arg).toFixed(0)).toLocaleString('en', {
    minimumFractionDigits: 0
  });
};

const firstDate = firstRequested => {
  return firstRequested || 'Jul 2019';
};

const lastDate = lastRequested => {
  return lastRequested || getDate();
};

export { removeCentsAddCommas, firstDate, lastDate };



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/utils.js